import { render } from "./DeleteUser.vue?vue&type=template&id=5bf73dec&ts=true"
import script from "./DeleteUser.ts?vue&type=script&lang=ts&external"
export * from "./DeleteUser.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__